<template>
  <!-- <v-row justify="center"> -->
  <v-dialog v-model="dialog" width="600" transition="dialog-bottom-transition">
    <!-- <v-sheet height="400" class="overflow-hidden" style="position: relative"> -->
    <template v-slot:activator="{ on, attrs }">
      <!-- <v-container class="fill-height">
          <v-row align="center" justify="center"> -->
      <v-btn
        color="primary white--text"
        filled
        block
        v-bind="attrs"
        v-on="on"
        @click.stop="drawer = !drawer"
        class="mb-5"
        style="text-transform: none"
      >
        <!-- <v-btn color="blue" small plain @click.stop="drawer = !drawer"> -->
        Update Email
      </v-btn>
      <!-- </v-row>
        </v-container> -->
    </template>
    <!-- <v-navigation-drawer width="auto" v-model="drawer" absolute temporary> -->
    <v-card flat>
      <v-form ref="form">
        <v-container fluid>
          <v-row>
            <v-col>
              <v-card-title style="word-break: break-word"
                >Update Email</v-card-title
              >
              <v-card-text>
                <div class="grey--text">
                  This will update you email on file as well as your sign in
                  email.
                </div>
              </v-card-text>
              <v-text-field
                single-line
                v-model="email"
                prepend-icon="mdi-email"
                :rules="emailRules"
                label="Email Address"
                id="sign-up-email"
                style="width: 250px"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <!-- <v-row class="justify-center mt-9 mb-2"> -->
          <!-- </v-row> -->
          <v-row class="justify-center mt-9 mb-2 mx-0">
            <updateemailverify
              @updateUserEmail="updateUserEmail"
              :email="email"
              @verifyEmailValidationCode="verifyEmailValidationCode"
            />
          </v-row>
          <v-row class="justify-center mt-9 mb-2">
            <v-btn
              small
              color="error"
              style="text-transform: none"
              class="cancel black--text"
              elevation="0"
              @click="close()"
            >
              Cancel
            </v-btn>
          </v-row>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
  <!-- </v-row> -->
</template>
<script>
import updateemailverify from '@/components/settings/updateemailverify.vue'
import * as mutations from '@/graphql/mutations.js'
import { Auth, API } from 'aws-amplify'
import { mapGetters } from 'vuex'

export default {
  name: 'EmailUpdate',
  components: {
    updateemailverify,
  },
  data() {
    return {
      iconIndex: 0,
      icons: [
        'mdi-emoticon',
        'mdi-emoticon-cool',
        'mdi-emoticon-dead',
        'mdi-emoticon-excited',
        'mdi-emoticon-happy',
        'mdi-emoticon-neutral',
        'mdi-emoticon-sad',
        'mdi-emoticon-tongue',
      ],
      email: '',
      code: '',
      drawer: null,
      dialog: false,
      storedGroups: [],
      emailRules: [
        (value) => !!value || 'Required',
        (value) =>
          !value ||
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) ||
          'E-mail must be valid',
      ],
      rules: {
        required: (value) => !!value || 'Required',
        min: (v) => v.length >= 8 || 'Min 8 characters',
        emailMatch: () => `The email and password you entered don't match`,
      },
    }
  },
  computed: {
    ...mapGetters({
      currentUserProfile: 'getcurrentlySelectedAccountInformationArray',
      groups: 'getUserGroups',
    }),
    icon() {
      return this.icons[this.iconIndex]
    },
  },
  watch: {},
  methods: {
    async updateUserEmail() {
      console.log('this.userprofile', this.currentUserProfile.userProfile)
      const user = await Auth.currentAuthenticatedUser()
      await Auth.updateUserAttributes(user, {
        email: this.email,
      })
        .then(() => {
          console.log('a verification code is sent')
        })
        .catch((e) => {
          console.error('failed with error', e)
        })
    },
    async verifyEmailValidationCode(code) {
      console.log('code', code)
      try {
        await Auth.verifyCurrentUserAttributeSubmit('email', code)
          .then(() => {
            console.log('email verified')
            if (this.storedGroups.includes('clients')) {
              this.updateUserProfile()
              this.close()
            }
          })
          .catch((e) => {
            console.error('failed with error', e)
          })
      } catch (error) {
        alert(error.message)
        console.log(error)
      }
    },
    async updateUserProfile() {
      console.log('this.userprofile', this.currentUserProfile.userProfile)
      console.log('this.email', this.email)
      try {
        await API.graphql({
          query: mutations.updateUserProfile,
          variables: {
            input: {
              // id: this.currentUserProfile.userProfile.id,
              id: this.currentUserProfile.userProfile.id,
              contactDetails: {
                familyName:
                  this.currentUserProfile.userProfile.contactDetails.familyName,
                givenName:
                  this.currentUserProfile.userProfile.contactDetails.givenName,
                phone: {
                  phoneNumber:
                    this.currentUserProfile.userProfile.contactDetails.phone[0]
                      .phoneNumber,
                  phoneType:
                    this.currentUserProfile.userProfile.contactDetails.phone[0]
                      .phoneType,
                },
                email: [this.email],
                // homeAddress: {
                //   city: this.editedItem.homeCity,
                //   country: this.editedItem.homeCountry,
                //   postal: this.editedItem.homePostal,
                //   state: this.editedItem.homeState,
                //   streets: this.editedItem.homeStreets,
                // },
                // mailingAddress: {
                //   city: this.editedItem.mailingCity,
                //   country: this.editedItem.mailingCountry,
                //   postal: this.editedItem.mailingPostal,
                //   state: this.editedItem.mailingState,
                //   streets: this.editedItem.mailingStreets,
                // },
              },
            },
          },
        })
      } catch (error) {
        console.error('update email user profile', error)
      }
    },
    close() {
      this.$refs.form.reset()
      this.dialog = false
    },
    resetIcon() {
      this.iconIndex = 0
    },
    changeIcon() {
      this.iconIndex === this.icons.length - 1
        ? (this.iconIndex = 0)
        : this.iconIndex++
    },
  },
  mounted: async function () {
    this.storedGroups = JSON.parse(localStorage.getItem('groups'))
  },
}
</script>
